import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { useTranslation } from 'react-i18next';

const EN_DEFAULTS = {
  heading: 'Ready to meet your favorite creators?',
  subheading: 'Join millions of fans discovering exclusive content every day.',
  primary_button_text: 'Join Free',
  secondary_button_text: 'Log In',
};

const CtaBlock = () => {
  const { t } = useTranslation('auth');
  const d = {
    heading: t('landing.cta.heading', EN_DEFAULTS.heading),
    subheading: t('landing.cta.subheading', EN_DEFAULTS.subheading),
    primary_button_text: t('landing.cta.primaryButton', EN_DEFAULTS.primary_button_text),
    secondary_button_text: t('landing.cta.secondaryButton', EN_DEFAULTS.secondary_button_text),
  };

  return (
    <section className="py-16 sm:py-24">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="relative rounded-[2rem] overflow-hidden">
          <div className="absolute inset-0" style={{ background: `linear-gradient(135deg, var(--color-primary, #10b981) 0%, #0a0a0a 50%, #1a1a2e 100%)` }} />
          <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: 'radial-gradient(circle, white 1px, transparent 1px)', backgroundSize: '28px 28px' }} />
          <div className="relative z-10 px-8 sm:px-16 py-20 sm:py-28 text-center">
            <h2 className="cl-serif text-3xl sm:text-4xl lg:text-[3.25rem] font-black text-white tracking-[-0.02em] leading-[1.1] mb-6">{d.heading}</h2>
            <p className="text-base sm:text-lg text-white/50 mb-10 max-w-xl mx-auto leading-relaxed font-light">{d.subheading}</p>
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
              <Link to="/register" className="group inline-flex items-center justify-center gap-2.5 px-9 py-4 rounded-full font-semibold text-[15px] text-black bg-white hover:bg-gray-100 transition-all hover:-translate-y-0.5 shadow-xl">
                {d.primary_button_text}
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform rtl:-scale-x-100" />
              </Link>
              <Link to="/login" className="inline-flex items-center justify-center gap-2 px-9 py-4 rounded-full font-semibold text-[15px] text-white border border-white/20 hover:bg-white/10 hover:border-white/30 transition-all hover:-translate-y-0.5">
                {d.secondary_button_text}
              </Link>
            </div>
            <p className="text-[13px] text-white/30 mt-7 font-medium">{t('landing.cta.noCreditCard', 'Free to join. Cancel anytime.')}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CtaBlock;
